/* eslint-disable no-nested-ternary */
import React, { useEffect } from 'react';
import clsx from 'clsx';
import { Flag, XOctagon } from 'react-feather';
import { useAppDispatch, useAppSelector } from '../../redux/reduxHooks';
import { Cell, gameSlice } from './game.slice';
import { generateBoardWithMines } from './game-board.helper';

export interface GameBoardProps {
  minesCount: number;
  rowsCount: number;
  colsCount: number;
}

const GameBoard: React.FC<GameBoardProps> = ({
  minesCount,
  rowsCount,
  colsCount,
}) => {
  const { grid, minesMarked, isDebug, isGameOver, win } = useAppSelector(
    state => state.game,
  );
  const dispatch = useAppDispatch();

  useEffect(() => {
    dispatch(
      gameSlice.actions.setGrid(
        generateBoardWithMines(minesCount, rowsCount, colsCount),
      ),
    );
  }, [dispatch, minesCount, rowsCount, colsCount]);

  useEffect(() => {
    const cellsLeft = grid?.reduce((rowAcc, row) => {
      return (
        rowAcc +
        row.reduce((cellAcc, cell) => {
          return cellAcc + (!cell.visible ? 1 : 0);
        }, 0)
      );
    }, 0);

    if (cellsLeft === minesCount) {
      dispatch(gameSlice.actions.setWin());
    }
  }, [grid, dispatch, minesCount]);

  const handleCellClick = (cell: Cell) => {
    if (!isGameOver && !cell.visible) {
      if (cell.value === 'X') {
        dispatch(gameSlice.actions.setGameOver());
      } else {
        dispatch(gameSlice.actions.concealCell(cell));
      }
    }
  };

  const handleMarkMine = (cell: Cell) => {
    if (!isGameOver && !cell.visible) {
      dispatch(
        cell.markedAsMine
          ? gameSlice.actions.unmarkMine(cell)
          : gameSlice.actions.markMine(cell),
      );
    }
  };

  return (
    <div
      className={clsx(
        'absolute left-0 right-0 top-0 bottom-0',
        'flex flex-col justify-center items-center',
      )}
    >
      {(isGameOver || win) && (
        <div className="flex justify-center items-center text-3xl text-white mb-5">
          {isGameOver ? 'Game over!!!' : 'You win!!!'}
        </div>
      )}

      <div className={clsx('bg-gray-700 rounded-sm', 'p-1')}>
        {/* <div>
          <label htmlFor="debug">
            <input
              id="debug"
              type="checkbox"
              checked={isDebug}
              onChange={e => {
                dispatch(gameSlice.actions.setDebug(e.target.checked));
              }}
            />
            <span className="ml-1">Show values</span>
          </label>
        </div> */}

        <div className={clsx('pb-2 px-1', 'flex justify-between')}>
          <div>
            Total Mines: <span>{minesCount}</span>
          </div>

          <div>
            Mines Marked: <span>{minesMarked}</span>
          </div>

          {/* <div>
            Time: <span>{minesCount}</span>
          </div> */}
        </div>

        <ul className={clsx('flex flex-col space-y-0.5')}>
          {grid &&
            grid.map((rows, rowIdx) => {
              return (
                <li key={Number(rowIdx)}>
                  <ul className={clsx('flex space-x-0.5')}>
                    {rows.map((cell, colIdx) => (
                      <button
                        type="button"
                        key={`${Number(rowIdx)}${Number(colIdx)}`}
                        className={clsx(
                          'w-12 h-12',
                          'transition-colors',
                          'rounded-sm',
                        )}
                        onClick={() => {
                          handleCellClick(cell);
                        }}
                        onContextMenu={e => {
                          e.preventDefault();
                          handleMarkMine(cell);
                        }}
                      >
                        <div
                          className={clsx(
                            'w-full h-full',
                            'flex justify-center items-center',
                            !cell.visible && 'bg-green-600 hover:bg-green-700',
                          )}
                        >
                          {isGameOver || win || cell.visible || isDebug ? (
                            cell.value === 'X' ? (
                              <XOctagon />
                            ) : (
                              cell.value
                            )
                          ) : cell.markedAsMine ? (
                            <Flag />
                          ) : (
                            ''
                          )}
                        </div>
                      </button>
                    ))}
                  </ul>
                </li>
              );
            })}
        </ul>
      </div>
    </div>
  );
};

export default GameBoard;
